import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchMeetupTarget } from "../api/fetchMeetupTarget";
import IxdaLogo from "../Components/IxdaLogo/IxdaLogo";

import "../styles/pages/meetupRedirectPage.scss";

export const MeetupRedirectPage = () => {
  const { source } = useParams();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    // sendBeacon is delivered even though the page navigates away right after
    const query = source ? `?source=${encodeURIComponent(source)}` : "";
    navigator.sendBeacon?.(`/.netlify/functions/meetup-click${query}`);

    fetchMeetupTarget().then(setTarget);
  }, [source]);

  // Redirect after the meetup name has rendered, so it shows while Meetup.com loads.
  // replace() keeps /meetup out of the history, so the back button doesn't bounce.
  useEffect(() => {
    if (target) window.location.replace(target.url);
  }, [target]);

  const event = target?.event;
  const color = event?.color || "white";

  return (
    <div className={`meetup-redirect ${color}`}>
      <IxdaLogo color={color} className="meetup-redirect-logo" />
      {event ? (
        <>
          <h2 className="meetup-redirect-subtitle">Taking you to Meetup #{event.eventMeetupNo}</h2>
          <h1 className="meetup-redirect-title">{event.eventName}</h1>
        </>
      ) : (
        <h1 className="meetup-redirect-title">
          {target ? "Taking you to the meetup" : "Finding the meetup…"}
        </h1>
      )}
      {target && (
        <a href={target.url} className="meetup-redirect-link">
          Not redirected? Open the meetup →
        </a>
      )}
    </div>
  );
};

export default MeetupRedirectPage;
